import { useEffect, useState } from "react";

const visibilityEvent = "office:admin-console-visibility";

const currentVisibility = () =>
    typeof document !== "undefined" && document.body.dataset.adminConsoleOpen === "true";

export const publishAdminConsoleVisibility = (open: boolean) => {
    if (typeof document === "undefined" || typeof window === "undefined") return;

    document.body.dataset.adminConsoleOpen = String(open);
    window.dispatchEvent(new CustomEvent<boolean>(visibilityEvent, { detail: open }));
};

export const useAdminConsoleVisibility = () => {
    const [open, setOpen] = useState(currentVisibility);

    useEffect(() => {
        const handleVisibility = (event: Event) => {
            setOpen((event as CustomEvent<boolean>).detail);
        };

        window.addEventListener(visibilityEvent, handleVisibility);
        setOpen(currentVisibility());
        return () => window.removeEventListener(visibilityEvent, handleVisibility);
    }, []);

    return open;
};
